<div class="page page--grey-bg" id="page-top">
  <app-loader></app-loader>
  <main class="page__main">
    <div class="wrap">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
